module.exports = __webpack_public_path__ + "static/media/Other-Well.d710e0de.jpg";